module.exports = __webpack_public_path__ + "img/mascot-logout.426bb646.svg";